import { Button } from '@mui/material';
import { AccountCircleRounded } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import {
  getterIsAdminValidLogin,
  getterOwnInfo,
} from '~/store/user/userGetter';
import { displayName } from '~/utils/helper/display';
import { useAppDispatch } from '~/store';
import { logout } from '~/store/user';
import { header } from './AdminHeader.style';

/** Header 右側「使用者圖示＋名稱＋登出」共用區塊（AdminHeader / LatestNewsHeader 共用） */
export const AdminHeaderProfile = () => {
  const dispatch = useAppDispatch();
  const isValidLogin = useSelector(getterIsAdminValidLogin);
  const ownInfo = useSelector(getterOwnInfo);

  return (
    <header.ProfileContainer>
      <AccountCircleRounded sx={{ fill: 'info.light' }} />
      {ownInfo && isValidLogin && (
        <>
          {displayName(ownInfo)}
          <Button
            variant="outlined"
            color="info"
            onClick={() => dispatch(logout())}
            sx={{ marginLeft: '8px' }}
          >
            登出
          </Button>
        </>
      )}
    </header.ProfileContainer>
  );
};
